module.exports = __webpack_public_path__ + "img/zi_2.c564c07c.png";